const Loading = () => (
  <div style={{ textAlign: 'center' }}>
    <img src='./spinner.svg' height='50px' alt='Loading' />
  </div>
);

export default Loading;
